module.exports = __webpack_public_path__ + "static/img/06-中国人民大学附属中学.424b51d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/06-中国人民大学附属中学.png
// module id = ka94
// module chunks = 0